__turbopack_context__.v({
  "checkout": "stylizedSelect-module-scss-module__U6XY-q__checkout",
  "container": "stylizedSelect-module-scss-module__U6XY-q__container",
  "control": "stylizedSelect-module-scss-module__U6XY-q__control",
  "indicatorSeparator": "stylizedSelect-module-scss-module__U6XY-q__indicatorSeparator",
  "inline": "stylizedSelect-module-scss-module__U6XY-q__inline",
  "isFocused": "stylizedSelect-module-scss-module__U6XY-q__isFocused",
  "isSelected": "stylizedSelect-module-scss-module__U6XY-q__isSelected",
  "menu": "stylizedSelect-module-scss-module__U6XY-q__menu",
  "option": "stylizedSelect-module-scss-module__U6XY-q__option",
  "province": "stylizedSelect-module-scss-module__U6XY-q__province",
  "required": "stylizedSelect-module-scss-module__U6XY-q__required",
  "selectWrapper": "stylizedSelect-module-scss-module__U6XY-q__selectWrapper",
  "small": "stylizedSelect-module-scss-module__U6XY-q__small",
});
